import { get } from 'lodash';
export const C_EXCEL_FILES_PATH = {

  1: {
    path: "/excel-files/Plantilla-proyecto-de-apartamentos.xlsx",
    name: "Plantilla proyecto de apartamentos"
  },
  2: {
    path: "/excel-files/Plantilla-proyecto-de-casas.xlsx",
    name: "Plantilla proyecto de casas"
  },
  3: {
    path: "/excel-files/Plantilla-proyecto-de-local-comercial.xlsx",
    name: "Plantilla proyecto de local comercial"
  },
  5: {
    path: "/excel-files/Plantilla-proyecto-de-nave-industrial.xlsx",
    name: "Plantilla proyecto de nave industrial"
  },
  6: {
    path: "/excel-files/Plantilla-proyecto-de-terrenos.xlsx",
    name: "Plantilla proyecto de terrenos"
  }
};


export const getExcelFilesPath = (idType: ExcelFilesPath) => get(C_EXCEL_FILES_PATH, idType);
type NumericKeys<T> = Extract<keyof T, number>;

export type ExcelFilesPath = NumericKeys<typeof C_EXCEL_FILES_PATH>;
